import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { DialogData } from '../../../../domain/common.model';
import { BlockerService } from '../../service/blocker.service';
import { AsideAction, SidenavAction, SidenavSide, SidenavTemplate } from '../../store/aside.action';
import { DialogAction } from '../../store/dialog.action';

interface Element {
    value: string;
    viewValue: string;
}

@Component({
    selector: 'app-styleguide',
    templateUrl: './styleguide.component.html',
    styleUrls: ['./styleguide.component.scss']
})
export class StyleguideComponent implements OnInit {

    checked = false;

    title = 'salespoint';
    elements: Element[] = [
        {value: '0', viewValue: 'Kontynuacja ubezpieczenia'},
        {value: '1', viewValue: 'Nowa polisa'},
    ];
    estates: Element[] = [
        {value: '0', viewValue: 'Mieszkanie'},
        {value: '1', viewValue: 'Dom'},
    ];
    notifications = [
        {
            status: 'RED',
            message: '10:20 Notification'
        },
        {
            status: 'YELLOW',
            message: '10:20 Notification'
        },
        {
            status: 'GREEN',
            message: '10:20 Notification'
        },
        {
            status: 'BLUE',
            message: '10:20 Notification'
        }
    ];

    constructor(private store: Store,
                private blockerService: BlockerService,
                private toastr: ToastrService,
                public dialog: MatDialog) {
    }

    ngOnInit(): void {
    }


    openAside() {
        this.store.dispatch(new AsideAction.Generic(SidenavSide.RIGHT, SidenavAction.OPEN, SidenavTemplate.GENERIC_ASIDE));
    }

    openMenu() {
        this.store.dispatch(new AsideAction.Generic(SidenavSide.LEFT, SidenavAction.OPEN, SidenavTemplate.MENU));
    }

    openConfig() {
        this.store.dispatch(new AsideAction.Generic(SidenavSide.RIGHT, SidenavAction.OPEN, SidenavTemplate.OFFER_PROPERTY_CONFIG));
    }


    openDialog(): void {
        const data = new DialogData();
        data.titleLabel = 'title';
        data.descriptionLabel = 'lorem ipsum';
        this.store.dispatch(new DialogAction.OpenGeneric(data));
    }


    showSuccessToaster() {
        this.toastr.success('Hello world!', 'Toastr fun!', {
            disableTimeOut: true,
        });
    }

    showErrorToaster() {
        this.toastr.error('Hello world!', 'Toastr fun!');
    }

    showWarningToaster() {
        this.toastr.warning('Hello world!', 'Toastr fun!');
    }

    showInfoToaster() {
        this.toastr.info('Hello world!', 'Toastr fun!');
    }

    openBlocker(timeout: number = 5000) {
        this.blockerService.increment();
        setTimeout(() => {
            this.blockerService.decrement();
        }, timeout);
    }

    openBlockerDialog() {
        this.openBlocker(50000000);
        this.openDialog();
        this.showSuccessToaster();
        this.showSuccessToaster();
        this.showSuccessToaster();
        this.showSuccessToaster();
        this.showSuccessToaster();
    }

}
